import type { ValueOf } from '../../types';

export const TooltipTrigger = {
  OnHover: 'onHover',
  OnClick: 'onClick',
} as const;
export type TooltipTrigger = ValueOf<typeof TooltipTrigger>;
